export default __webpack_public_path__ + "static/rohit-d35ba6168a3d1899286ab33a519711c9.jpg";